module.exports = __webpack_public_path__ + "04c2fd665ba6462fb14fab80ae7af721.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/accounts/group-accounts.html
// module id = 2154
// module chunks = 0